import React from 'react';

function Menu() {
    return (
            <header class="container-fluid">
                <div class="row">
                    <div class="wrapper">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="block-img">
                                        <a href="https://sureshot-armament.com/" target="_blank"><img src="images/logo.png" alt="alt"/></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="row">
                                        <div class="block-img">
                                        <a href="http://www.dytac.hk/" target="_blank"><img src="images/logo_2.png" alt="alt"/></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            )
}

export default Menu


